export const URL_SUPPORT = 'https://support.fabfitfun.com/?a=How-can-I-contact-Customer-Care---id--2tnlqvo8SqWH7h_ujSe5NQ';
